// store/authInitialState.ts
import {
  AaeResponseDto,
  AarDraftResponseDto,
  CapResponseDto,
  CcaPcaResponseDto,
  CutOffQueryParams,
  FaeResponseDto,
  FnpDraftResponseDto,
  ParResponseDto,
} from '../../types';

/**
 * @french
 * État initial du slice d’authentification.
 */
export const cutOffInitialState = {
  queryParams: null as CutOffQueryParams | null,
  selectedCcaPca: null as CcaPcaResponseDto | null,
  isUpdateModalVisible: false,

  deleteModalVisibility: 'hidden' as
    | 'hidden'
    | 'showFnp'
    | 'showAar'
    | 'showCcaPca'
    | 'showFae'
    | 'showAae'
    | 'showPar'
    | 'showCap',

  selectedRecord: null as CcaPcaResponseDto | null,
  selectedFnp: null as FnpDraftResponseDto | null,
  selectedAar: null as AarDraftResponseDto | null,
  selectedFae: null as FaeResponseDto | null,
  selectedAae: null as AaeResponseDto | null,
  selectedCap: null as CapResponseDto | null,
  selectedPar: null as ParResponseDto | null,
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type CutOffState = typeof cutOffInitialState;
